var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"value":_vm.valor,"label":_vm.dadosForm('rotulo'),"rules":_vm.dadosForm('regra'),"rows":_vm.dadosForm('linhas'),"disabled":_vm.dadosForm('desativado'),"prepend-inner-icon":"mdi-comment","counter":"","clearable":"","solo":"","outlined":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }